interface Props { status: string; statusFormatted: string; className?: string; }

const COLORS: Record<string, string> = {
    NOT_STARTED: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
    IN_PROGRESS: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
    CONFIRMED: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
    PARTIALLY_CONFIRMED: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300',
    REJECTED: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
};

const DraweeConfirmationStatusBadge = ({ status, statusFormatted, className = '' }: Props) => {
    const color = COLORS[status] || COLORS.NOT_STARTED || 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
    return <span className={`px-2 py-0.5 rounded text-[10px] font-medium ${color} ${className}`}>{statusFormatted || '—'}</span>;
};

export default DraweeConfirmationStatusBadge;
